import Component from './Component';

export default class VimeoBanner extends Component {
  load() {
    var video_id = $("#vimeobgplayer").data('id');
    $.ajax({
      type:'GET',
      url: 'https://vimeo.com/api/v2/video/' + video_id + '.json',
      jsonp: 'callback',
      dataType: 'jsonp',
      success: function(data){
          var thumbnail_src = data[0].thumbnail_large;
          $('.banner__container').css('background-image', 'url(' +thumbnail_src +')');
      }
  });
    super.load();
}
}
